import React, { useId } from 'react';
export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}
export function Textarea({
  className = '',
  label,
  error,
  id,
  ...props
}: TextareaProps) {
  const textareaId = id || useId();
  return <div className="w-full space-y-2" data-id="element-273">
      {label && <label htmlFor={textareaId} className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-gray-700" data-id="element-274">
          {label}
        </label>}
      <textarea id={textareaId} className={`flex min-h-[80px] w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50 ${error ? 'border-red-500 focus:ring-red-500' : ''} ${className}`} {...props} data-id="element-275" />
      {error && <p className="text-sm text-red-500" data-id="element-276">{error}</p>}
    </div>;
}